import { ControlValidationType, FormNode } from '@msdk/definitions'

export function nodeHasFlag(node: FormNode, flag: ControlValidationType): boolean {
  return (node.value.validationFlags & flag) === flag
}
